import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {useEffect, useLayoutEffect, useState} from 'react'
import {Hub, repeatTemplatesContainerId} from 'yougile-model'
import {ContextTaskProvider} from '@api/shared/context/context-task'
import {UiLocationProvider} from '@api/shared/context/ui-location'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {WorkflowInTask} from '@components/workflow/workflow-in-task'
import {useSyncEvent} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {taskPhantomObserver} from '@extensions/task-phantom-observer'
import {ConnectedTasks} from './connected-tasks'
import {TaskInfo} from './task-info'
import {TaskInfoLogContext, TaskInfoLogStore} from './task-info-log-store'

type Props = {
  hub: Hub
}

export const TaskInfoLog = observer(({hub}: Props) => {
  const [store] = useState(() => new TaskInfoLogStore())

  useLayoutEffect(() => {
    store.syncOnNew(hub)
  }, [hub])

  useSyncEvent(
    'current',
    {filter: hub?.id},
    () => {
      store.syncOnUpdate()
    },
    [hub]
  )

  useEffect(() => {
    store.syncOnUpdate()
  }, [taskPhantomObserver.modified])

  if (!hub) {
    return null
  }

  return (
    <UiLocationProvider location="task-info">
      <ContextTaskProvider taskId={hub.id}>
        <TaskInfoLogContext.Provider value={store}>
          <WithPerfectScrollbar>
            <div className="chat-connected task-info">
              <TaskInfo />
              <WorkflowInTask taskId={hub.id} />
              {!globals.sharedId &&
                hub.location !== repeatTemplatesContainerId && (
                  <ConnectedTasks />
                )}
            </div>
          </WithPerfectScrollbar>
        </TaskInfoLogContext.Provider>
      </ContextTaskProvider>
    </UiLocationProvider>
  )
})
